import { loginConstants } from "../../actionTypes";

const loggedInUserData = (payload: any) => {
  return (dispatch: any) => {
    dispatch({ type: loginConstants.LOGGEDIN_USERDATA, payload });
  };
}

const loggedInUserPermission = (payload: any) => {
  return (dispatch: any) => {
    dispatch({ type: loginConstants.LOGGEDIN_USERPERMISSION, payload });
  };
}



export const LoginActions = {
  loggedInUserData,
  loggedInUserPermission
};
